const blobCache = new Map();

export function getCachedBlob(url) {
    return blobCache.get(url);
}

export function setCachedBlob(url, blobUrl) {
    blobCache.set(url, blobUrl);
}

export function removeCachedBlob(url) {
    const value = blobCache.get(url);
    blobCache.delete(url);

    if (typeof value === 'string') {
        URL.revokeObjectURL(value);
    }
}

export function clearBlobCache() {
    for (const blobUrl of blobCache.values()) {
        URL.revokeObjectURL(blobUrl);
    }

    blobCache.clear();
}
